export const retryStrategy = (failureCount: any, error: any) => {
  const maxRetries = 3;
  if (failureCount >= maxRetries - 1) return false;

  // Don't retry 404s or 401s (unauthorized)
  if (error?.response?.status === 404 || error?.response?.status === 401) {
    return false;
  }

  return true;
};
